module.exports = __webpack_public_path__ + "static/src/content/images/viddora.84bd6ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/viddora.png
// module id = zonP
// module chunks = 0